const INTENDED_ROUTE_KEY = 'tonesmith:intendedRoute'

/**
 * Store an intended route for redirecting after authentication.
 */
export function setIntendedRoute(path: string) {
  if (!path) return
  sessionStorage.setItem(INTENDED_ROUTE_KEY, path)
}

/**
 * Read the currently stored intended route without clearing it.
 */
export function getIntendedRoute(): string | null {
  return sessionStorage.getItem(INTENDED_ROUTE_KEY)
}

/**
 * Read and clear the stored intended route.
 */
export function consumeIntendedRoute(): string | null {
  const path = getIntendedRoute()
  if (path) {
    clearIntendedRoute()
  }
  return path
}

/**
 * Remove the stored intended route.
 */
export function clearIntendedRoute() {
  sessionStorage.removeItem(INTENDED_ROUTE_KEY)
}

export { INTENDED_ROUTE_KEY }

